import { driver } from "driver.js";
import "driver.js/dist/driver.css";

const DONE_KEY = "sl_tour_done_v1";

// Build a step; if the target element isn't on screen (e.g. collapsed mobile nav),
// gracefully fall back to a centered popover with the same copy.
function step(selector, popover) {
  if (selector && document.querySelector(selector)) return { element: selector, popover };
  return { popover: { ...popover, side: "over", align: "center" } };
}

export function startTour() {
  const d = driver({
    showProgress: true,
    allowClose: true,
    nextBtnText: "Next →",
    prevBtnText: "← Back",
    doneBtnText: "Got it",
    popoverClass: "sl-tour",
    onDestroyed: () => localStorage.setItem(DONE_KEY, "1"),
    steps: [
      { popover: {
          title: "Welcome to SidelineIQ 🏟️",
          description: "Your edge before the line moves. This 45-second tour shows you around — no sign-up needed to explore.",
          side: "over", align: "center",
      }},
      step('[data-testid="events-list"]', {
        title: "Live status feed",
        description: "Every injury, scratch, trade & lineup change across NFL, NBA, NHL & MLB — each card cited with its source and last-updated time. Filter by league or category up top.",
      }),
      step('[data-testid="nav-parlay"]', {
        title: "Parlay Risk Scanner",
        description: "Drop players into a slip and get a Slip Health Index that flags open status concerns. It never picks bets — it surfaces information gaps.",
      }),
      step('[data-testid="nav-watchlist"]', {
        title: "Named watchlists",
        description: "Build watchlists (e.g. \"Sunday Parlay\", \"NBA fades\") and get alerts only on the players you track. You can start one right now as a guest.",
      }),
      step('[data-testid="nav-pro"]', {
        title: "Go Pro for the real-time edge",
        description: "Free gives you a 30-minute delayed feed. Go All-Star (or grab a lifetime Founder pass) to get every update the moment it lands, with priority alerts and bigger watchlists.",
      }),
      step('[data-testid="share-btn"]', {
        title: "Share with friends & family",
        description: "Tap here anytime to copy the link and send SidelineIQ to your group chat.",
      }),
      { popover: {
          title: "You're all set 🎯",
          description: "Explore freely as a guest, or create a free account to save your watchlists and turn on alerts.",
          side: "over", align: "center",
      }},
    ],
  });
  d.drive();
}

export function maybeAutoStartTour() {
  if (localStorage.getItem(DONE_KEY)) return;
  // let the feed render first so highlight targets exist
  setTimeout(startTour, 900);
}
